import React, { useState, useEffect } from "react";

import cn from "classnames";
import Footer from "components/Footer";
import Header from "components/Header";
import Headroom from "react-headroom";
import styles from "./Test.module.scss";

const endpoint2 = `http://127.0.0.1:5001/draperu-talenter/us-central1`;
const endpoint = `https://us-central1-draperu-talenter.cloudfunctions.net`;

async function Post(url) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };
  const response = await fetch(url, requestOptions);
  const data = await response.json();
  return data;
}

const FAQList = [
  { key: "q0", q: "" },
  { key: "q1", q: "How many years of experience do they have?" },
  {
    key: "q2",
    q: "Can you provide an overview of his professional background and experience?",
  },
  {
    key: "q3",
    q: "What specific skills or expertise does the candidate possess?",
  },
  { key: "q4", q: "Where is his current company?" },
];

// className={cn(styles.root, 'about-us')}
export default function Test() {
  const [statusMessage, setStatusMessage] = React.useState("");
  const [isFetching, setIsFetching] = React.useState(false);

  const [email, setEmail] = React.useState("chris.chang@pxcode.io");
  const [linkedInLink, setLinkedInLink] = React.useState("miraclechris"); // https://www.linkedin.com/in/

  // create
  const updateInputValue = (evt) => {
    const val = evt.target.value;
    setLinkedInLink(val);
  };
  const updateInputEmail = (evt) => {
    const val = evt.target.value;
    setEmail(val);
  };
  const createResume = async (e) => {
    setStatusMessage("processing.....");
    const json = await Post(
      `${endpoint}/linkedin?email=${email}&q=${linkedInLink}`
    );
    console.log(json);
    setStatusMessage("");
    alert(JSON.stringify(json));
  };

  // qa -----------
  const [userHash, setUserHash] = React.useState("92c28dd1d2d5eb26");
  const [question, setQuestion] = React.useState(
    "What is his current company and his major skills?"
  );
  const [messages, setMessages] = React.useState([
    { type: "s", message: "You can ask questions ...." },
  ]);
  const [currentFAQKey, setCurrentFAQKey] = React.useState("q0");

  const updateInputQuestion = (evt) => {
    const val = evt.target.value;
    setQuestion(val);
  };
  const updateInputUserHash = (evt) => {
    const val = evt.target.value;
    setUserHash(val);
  };
  const doAsk = async (q = null) => {
    setStatusMessage("processing.....");
    const m = [...messages, { type: "q", message: q ? q : question }];
    console.log(m);
    setMessages(m);

    const json = await Post(`${endpoint}/qa?id=${userHash}&q=${question}`);
    setStatusMessage("");
    setMessages([...m, { type: "a", message: json.answer }]);
  };
  const doFAQ = (e) => {
    let key = e.target.value;
    console.log(key);
    let faqItem = FAQList.filter(function (item) {
      return item.key === key;
    })[0];
    if (faqItem) {
      doAsk(faqItem.q);
    }
  };

  return (
    <div>
      <h1>Create Resume</h1>
      <hr />
      <h3>Please Input Email</h3>
      <input value={email} onChange={(evt) => updateInputEmail(evt)} />
      <h3>Please Input Your LinkedIn</h3>
      <input value={linkedInLink} onChange={(evt) => updateInputValue(evt)} />
      <h3>Please Input Your Github</h3>
      <input />
      <br />
      <button onClick={createResume}>Submit</button>
      <div>{statusMessage}</div>
      <br />
      <hr />
      <br />
      <h1>Q & A</h1>
      <div style={{ textAlign: "left" }}>
        {messages.map((m, i) => {
          if (m.type === "q")
            return (
              <div
                style={{
                  marginBottom: 8,
                  borderRadius: 4,
                  border: "1px solid white",
                  backgroundColor: "pink",
                  marginLeft: 0,
                }}
              >
                <div style={{ padding: 4 }}>{m.message}</div>
              </div>
            );
          else if (m.type === "s")
            return (
              <div
                style={{
                  marginBottom: 8,
                  borderRadius: 4,
                  border: "1px solid white",
                  backgroundColor: "white",
                  marginLeft: 0,
                }}
              >
                <div style={{ padding: 4 }}>{m.message}</div>
              </div>
            );
          else
            return (
              <div
                style={{
                  marginBottom: 8,
                  borderRadius: 4,
                  border: "1px solid white",
                  backgroundColor: "lightblue",
                  marginLeft: 200,
                }}
              >
                <div style={{ padding: 4 }}>{m.message}</div>
              </div>
            );
        })}
      </div>
      <h3>UserID</h3>
      <input value={userHash} onChange={(evt) => updateInputUserHash(evt)} />
      <br />
      <select id="lang" onChange={doFAQ} value={currentFAQKey}>
        {FAQList.map((faq, index) => {
          return <option value={`${faq.key}`}>{faq.q}</option>;
        })}
      </select>
      <h3>How many years of experience do they have?</h3>
      <input value={question} onChange={(evt) => updateInputQuestion(evt)} />
      <button onClick={() => doAsk()}>Ask</button>
      <hr />
    </div>
  );
}
